import $api from '../config/api'

export const getSocialMedia = async () => {
  const response = await $api.get('/social-media')
  return response.data
}

export const createSocialMedia = async (reqData: {
  link: string
  enabled: boolean
  name: string
}) => {
  const response = await $api.post('/social-media', reqData)
  return response.data
}

export const updateSocialMedia = async (
  reqData: {
    link?: string
    enabled?: boolean
    name?: string
    icon?: string
  },
  id: string,
) => {
  const response = await $api.patch(`/social-media/${id}`, reqData)
  return response.data
}

export const updateOrder = async (reqData: IdsPayload) => {
  const response = await $api.put('/social-media/order', reqData)
  return response.data
}

export const removeSocialMedia = async (id: string) => {
  const response = await $api.delete(`/social-media/${id}`)
  return response.data
}
